export const HEALTH_METER_TYPES = {
    POOR: 'poor',
    FAIR: 'fair',
    OPTIMAL: 'optimal',
};

export const HEALTH_METER_SIZES = {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
};
